import React from 'react'

import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'

const ContentHeader = ({ title, subtitle, children }) => (
  <Box
    mb={2}
    display="flex"
    justifyContent="space-between"
    alignItems="flex-end"
  >
    <Box>
      <Typography variant="overline">{subtitle}</Typography>
      <Typography variant="h3">{title}</Typography>
    </Box>
    <Box>{children}</Box>
  </Box>
)

export default ContentHeader
